/** Capability detection used to give honest instructions per platform. */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
}

export type PushSupport =
  | { kind: 'supported' }
  | { kind: 'ios-needs-install' }
  | { kind: 'denied' }
  | { kind: 'unsupported' }
  | { kind: 'not-configured' };

/**
 * Web Push on iPhone works only for a web app added to the Home Screen (iOS 16.4+).
 * In a regular Safari tab the API is absent: we say so instead of promising push.
 */
export function pushSupport(vapidKey: string): PushSupport {
  if (!vapidKey) return { kind: 'not-configured' };
  const hasApi =
    typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  if (!hasApi) return isIos() && !isStandalone() ? { kind: 'ios-needs-install' } : { kind: 'unsupported' };
  if (Notification.permission === 'denied') return { kind: 'denied' };
  return { kind: 'supported' };
}

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}
